/* eslint-disable sort-keys */
const URLS = {
  // general
  HELP: '/help',
  HELP_CATEGORY: '/help/tag/:category',
  HELP_VIDEO: '/help/:videoSlug',
  ROOT: '/',

  // lessons
  IT: '/slideviewer/4567/projection/2130851',
  SCRATCH: '/slideviewer/1848/projection/2035985',
  WIJS: '/slideviewer/4209/projection/2123708',

  // public routes
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_SERVICE: '/terms-of-service',

  // exercise
  EXERCISE: '/exercises',
  EXERCISE_DETAIL: `/exercises/detail/:exerciseId`, // todo: this is no longer used, definitely needs studioId?
  EXERCISE_NEW: `/exercises/new`,
  EXERCISE_OPEN: `/exercises/open/:userId/:exerciseVersionId`,
  EXERCISE_OVERVIEW: '/exercises',
  EXERCISE_START: `/exercises/start/:studioId/`,
  EXERCISE_START_EXERCISEVERSIONID: `/exercises/start/:studioId/:exerciseVersionId/:oldSessionId?`, // Added sessionID as an optional param so old links still work

  // slideviewer
  SLIDEVIEWER: '/slideviewer',
  SLIDEVIEWER_HACKROOM_LESSON:
    '/slideviewer/hackroom/lesson/:studioId/:viewMode?/:slideId?',
  SLIDEVIEWER_OVERVIEW: '/slideviewer/:studioId',
  SLIDEVIEWER_OVERVIEW_VIEWMODE: '/slideviewer/:studioId/:viewMode',
  SLIDEVIEWER_OVERVIEW_SLIDE_VIEWMODE_SLIDEID:
    '/slideviewer/:studioId/:viewMode/:slideId',

  MULTI_SCREEN: '/multiscreen',
};

export default URLS;
